import { Component, Input, Output, EventEmitter, HostListener, ChangeDetectorRef } from '@angular/core'

@Component({
    selector: 'app-multi-select-dropdown',
    templateUrl: './multi-select-dropdown.component.html',
    styleUrls: ['./multi-select-dropdown.component.scss'],
})
export class MultiSelectDropdownComponent {
    @Input() statuses: { id: number; name: string; selected: boolean }[] = []
    @Input() label = 'Selecione o status'
    @Output() statusChange = new EventEmitter<{ id: number; name: string; selected: boolean }[]>()

    isDropdownOpen = false

    constructor(private cdr: ChangeDetectorRef) {}

    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen
    }

    isAnySelected(): boolean {
        return this.statuses.some(status => status.selected)
    }

    onStatusChange(status: { id: number; name: string; selected: boolean }): void {
        status.selected = !status.selected
        this.statusChange.emit(this.statuses)
    }

    @HostListener('document:click', ['$event'])
    closeDropdown(event: MouseEvent): void {
        const clickedInside = (event.target as HTMLElement).closest('.dropdown')

        if (!clickedInside) {
            this.isDropdownOpen = false
            this.cdr.detectChanges()
        }
    }
}
